<div class="inner-page-header py-5 text-white">
    <div class="container px-lg-5">
        <h1 class="display-5 fw-bold text-uppercase mb-2">Certificate / Skill Oriented Courses</h1>
        <p class="lead mb-0 text-orange-light">Crafting Expertise for a Brighter Future</p>
    </div>
</div>

<div class="container px-lg-5 py-5">

    <!-- Banner Image Placeholder -->
    <div class="skill-banner-wrap mb-4">
        <!-- TODO: Replace src with actual skill banner image path -->
        <img src="/assets/img/home/Skill-oriented-courses.png" alt="Enhance Skill Level" class="skill-banner-img">
        <!-- Placeholder overlay shown when no image is set -->
        <div class="skill-banner-placeholder d-flex flex-column align-items-center justify-content-center">
            <i class="fa-solid fa-image fa-3x mb-3 text-muted"></i>
            <span class="text-muted fw-semibold">Banner Image — replace with actual asset</span>
        </div>
    </div>

    <!-- Quote -->
    <p class="skill-quote text-center mb-4">"Crafting Expertise for a Brighter Future."</p>

    <!-- Course List — 3 columns -->
    <div class="row g-0 course-list-row mb-5">

        <!-- Column 1: 1–10 -->
        <div class="col-12 col-md-4">
            <ol class="course-list" start="1">
                <li>Basic Computer</li>
                <li>Basics of French Language</li>
                <li>Public Speaking</li>
                <li>Spoken English</li>
                <li>E-Banking System</li>
                <li>Yoga</li>
                <li>Cooking for Learning and Fun</li>
                <li>Green Chemistry</li>
                <li>Event Management</li>
                <li>Taxation and Finance</li>
            </ol>
        </div>

        <!-- Column 2: 11–20 -->
        <div class="col-12 col-md-4">
            <ol class="course-list" start="11">
                <li>Language Skills</li>
                <li>Environmental Chemistry</li>
                <li>Public Relations</li>
                <li>Yoga, Health and Hygiene</li>
                <li>Personality Development</li>
                <li>Vedic Maths</li>
                <li>Behavior Management</li>
                <li>Food and Nutrition</li>
                <li>Self Defence</li>
                <li>Game of Volleyball</li>
            </ol>
        </div>

        <!-- Column 3: 21–29 -->
        <div class="col-12 col-md-4">
            <ol class="course-list" start="21">
                <li>Cookery and Bakery</li>
                <li>Singing</li>
                <li>Folk Dances</li>
                <li>Social Media Content</li>
                <li>Art of Crochet</li>
                <li>Creative Print Design</li>
                <li>Waste Craft</li>
                <li>Fitness Mantra</li>
                <li>First Aid Training</li>
            </ol>
        </div>

    </div>

    <!-- Registration Button -->
    <div class="mb-5">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdZd8l-FA-DFB1C2fWz9OLhFzHjBM2bFb-hZXUJKDE0shHEMw/viewform"
            target="_blank" class="registration-btn">
            REGISTRATION <i class="fa-solid fa-arrow-right ms-2"></i>
        </a>
    </div>

    <!-- Registration Form Placeholder -->
    <!-- <div id="registration-form" class="registration-form-placeholder">
        <div class="d-flex flex-column align-items-center justify-content-center gap-3 py-5">
            <i class="fa-solid fa-file-pen fa-3x text-muted"></i>
            <span class="text-muted fw-semibold fs-5">Registration Form — embed or link here</span>
            <span class="text-muted small">Replace this placeholder with an embedded Google Form, PDF link, or custom
                form component.</span>
        </div>
    </div> -->

</div>